import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import api from '../../services/ApiManagement/Index';
import { useAuth } from '../../hooks/auth';
import { useOnlineStatus } from '../../hooks/onlineStatus';

import BackHeader from '../../components/BackHeader';
import PrivateMessage from '../../components/PrivateMessage';
import { Skeleton } from '../../components/Generic';
import { Container, LoadingHeader, Content } from './styles';

import Owned from './Owned';
import NotOwned from './NotOwned';

const LoadingComponent: React.FC = () => {
  return (
    <Container>
      <BackHeader title="Propriedade" />

      <LoadingHeader>
        <Skeleton />
      </LoadingHeader>

      <Content style={{ display: 'flex', flexDirection: 'column' }}>
        <Skeleton
          style={{
            height: 35,
            width: 260,
            marginBottom: 20,
            display: 'inline-block',
          }}
        />
        <Skeleton
          style={{
            height: 35,
            width: 160,
            marginBottom: 30,
            display: 'inline-block',
          }}
        />

        <Skeleton style={{ height: 20, width: 200, display: 'inline-block' }} />
      </Content>
    </Container>
  );
};

const PrivateProperty: React.FC = () => {
  return (
    <Container>
      <BackHeader title="Propriedade" />

      <Content>
        <PrivateMessage />
      </Content>
    </Container>
  );
};

const Property: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [isOwner, setisOwner] = useState(false);
  const [property, setProperty] = useState<any>();
  const [owner, setOwner] = useState({});
  const [isContributor, setIsContributor] = useState<boolean>(false);
  const [isPrivate, setIsPrivate] = useState<boolean>(false);

  const { id }: any = useParams();
  const { user } = useAuth();
  const isOnline = useOnlineStatus();

  useEffect(() => {
    getProperty();
  }, []);

  const getProperty = async () => {
    try {
      setLoading(true);

      // Propriedade
      const response = await api.get(
        `/propriedades/`,
        isOnline,
        'propriedades',
        {
          headers: {
            propriedade_id: id,
          },
        },
      );

      setProperty(response.data);
      console.log(response.data);

      // Proprietário
      if (response.data.proprietario_id === user.id) {
        setisOwner(true);
      } else {
        setOwner({
          ...response.data.usuarios,
          id: response.data.proprietario_id,
        });

        // Faz parte?
        const userExists = response.data.colaboradores.some((el: any) => {
          return el.usuario_id === user.id;
        });
        setIsContributor(userExists);
      }

      setLoading(false);
    } catch (err: any) {
      console.log(err);

      if (err.response?.status === 400) {
        setIsPrivate(true);
      }
    }
  };

  return loading ? (
    isPrivate ? (
      <PrivateProperty />
    ) : (
      <LoadingComponent />
    )
  ) : isOwner ? (
    <Owned property={property} />
  ) : (
    <NotOwned property={property} owner={owner} isContributor={isContributor} />
  );
};

export default Property;
